var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 11.97a2 2 0 0 0-.679-1.5L11.995 2.27a1.202 1.202 0 0 0-1.96.985c.014.31.149.604.375.817l7.205 6.332a.208.208 0 0 1-.137.365H3.2A1.2 1.2 0 0 0 2 11.97a1.2 1.2 0 0 0 1.201 1.2h14.274a.21.21 0 0 1 .138.364l-7.205 6.333a1.2 1.2 0 0 0-.147 1.725 1.2 1.2 0 0 0 1.732.075l9.327-8.198a2 2 0 0 0 .68-1.5"
  })));
};
export default SvgArrowRight;